/** Error boundary global — capture les erreurs de rendu React. */
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';

interface State {
  hasError: boolean;
  message?: string;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Sprint 1 : envoi vers le Worker (observabilité).
    // eslint-disable-next-line no-console
    console.error('[nexacraft:error-boundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm" sx={{ py: 10 }}>
          <Box role="alert" sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
              Une erreur est survenue
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              {this.state.message ?? 'Erreur inattendue. Veuillez réessayer.'}
            </Typography>
            <Button variant="contained" onClick={() => window.location.assign('/')}>
              Retour à l'accueil
            </Button>
          </Box>
        </Container>
      );
    }
    return this.props.children;
  }
}
